import { ObservationData } from '../../Types';

/**
 * Interface for tooltip content that can be rendered in a div element
 */
export interface TooltipContent {
  /**
   * Renders the content into the provided HTML div element
   * @param element - The HTML div element to render the content into
   */
  render(element: HTMLDivElement): void;
}

/**
 * Implementation of TooltipContent for observation data
 */
export class ObservationContent implements TooltipContent {
  constructor(private data: ObservationData[]) {}

  render(container: HTMLDivElement): void {
    this.data.forEach((data) => {
      const element = document.createElement('div');
      element.style.fontSize = '14px';
      element.style.fontWeight = 'normal';
      element.style.marginBottom = '5px';
      element.innerHTML = `${
        data.title !== 'title' && data.title !== 'number' ? `${data.title}: ` : ''
      }${data.title === 'number' ? `#${data.value}` : `<b>${data.value}</b>`}`;
      container.appendChild(element);
    });
  }
}

/**
 * Implementation of TooltipContent for title content
 */
export class TitleContent implements TooltipContent {
  constructor(private title: string) {}

  render(container: HTMLDivElement): void {
    const titleElement = document.createElement('div');
    titleElement.style.fontSize = '16px';
    titleElement.style.fontWeight = 'bold';
    titleElement.style.marginBottom = '8px';
    titleElement.innerText = this.title;
    container.appendChild(titleElement);
  }
}
